enum PlanIntervalUnits {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
}

export default PlanIntervalUnits;
